import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import Load from './Components/Load';
import './i18n'
import { SessionProvider } from './Services/Auth/sessionAuth';
import * as serviceWorker from '../src/Config/serviceWorkerRegistration';
import axios from 'axios';


//import { QueryClientProvider,QueryClient } from '@tanstack/react-query';
//527 e 3366 ch  
//const queryClient = new QueryClient();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

axios.defaults.withCredentials = true;



axios.interceptors.request.use((config) => {



  if (config.headers?.Authorization) {



    delete config.headers.Authorization;



  }



  return config;



});



axios.interceptors.response.use(



  (response) => response,



  (error) => {



    const url = String(error.config?.url ?? '').toLowerCase();



    const isAuthenticationFlow = url.includes('/authentification/connexion')



      || url.includes('/authentification/verify-otp')



      || url.includes('/authentification/session')



      || url.includes('/authentification/logout');







    if (error.response?.status === 401 && !isAuthenticationFlow) {



      console.warn('[AUTH DEBUG] authenticated request rejected with HTTP 401', {



        url,



        method: error.config?.method ?? null,



      });



      window.dispatchEvent(new Event('auth:expired'));



      window.location.replace('/Login');



    }







    if (error.response?.status === 403) {



      console.warn('[AUTH DEBUG] request rejected with HTTP 403', {

        url,

        method: error.config?.method ?? null,

        message: error.response?.data?.Message ?? error.response?.data?.message ?? 'No message',

        mfaMethod: error.response?.data?.MfaMethod,

        mfaRequired: error.response?.data?.MfaRequired,

        requiresSetup: error.response?.data?.RequiresSetup,

      });



      // Stocker la méthode MFA assignée si disponible

      if (error.response?.data?.MfaMethod) {

        sessionStorage.setItem('assignedMfaMethod', error.response.data.MfaMethod);

      }

      if (error.response?.data?.MfaRequired !== undefined) {

        sessionStorage.setItem('mfaRequired', String(error.response.data.MfaRequired));

      }

      if (error.response?.data?.RequiresSetup !== undefined) {

        sessionStorage.setItem('requiresSetup', String(error.response.data.RequiresSetup));

      }



      window.dispatchEvent(new Event('auth:forbidden'));



      // Rediriger selon l'état MFA

      const requiresSetup = error.response?.data?.RequiresSetup === true;

      

      if (requiresSetup) {

        // MFA non configuré → rediriger vers l'interface d'activation

        if (!window.location.pathname.toLowerCase().startsWith('/mfa-activation')) {

          window.location.replace('/mfa-activation');

        }

      } else {

        // MFA configuré mais non vérifié → rediriger vers l'interface de vérification

        if (!window.location.pathname.toLowerCase().startsWith('/mfa-verify')) {

          window.location.replace('/mfa-verify');

        }

      }



    }







    return Promise.reject(error);



  }



);







root.render(

  <BrowserRouter>

    <Suspense fallback={<Load />}>

      <SessionProvider>

        <App />

      </SessionProvider>

    </Suspense>

  </BrowserRouter>

);







serviceWorker.register();







// If you want to start measuring performance in your app, pass a function



// to log results (for example: reportWebVitals(console.log))



// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals







reportWebVitals();